/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Triggers
 */
export interface Triggers {
}

/**
 * Check if a given object implements the Triggers interface.
 */
export function instanceOfTriggers(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TriggersFromJSON(json: any): Triggers {
    return TriggersFromJSONTyped(json, false);
}

export function TriggersFromJSONTyped(json: any, ignoreDiscriminator: boolean): Triggers {
    return json;
}

export function TriggersToJSON(value?: Triggers | null): any {
    return value;
}

